const SINGLE_MENU_ITEM_ICON_MAPPER: Record<string, string> = {
  PRODUCTS: 'barcode',
  PRODUCT_CLASSES: 'style',
  PRICE_LISTS: 'checklist',
  // A weighing scale reads as measurement, and is distinct from the other Products-group icons.
  MEASUREMENT_UNITS: 'scale',
  // A branching tree reads as one axis splitting into its values.
  VARIANT_TYPES: 'account_tree',
  // Chips read as the individual values hanging off that axis.
  VARIANT_TYPE_OPTIONS: 'chips',
  // A price tag reads as an offer, and is distinct from the other Products-group icons.
  DISCOUNTS: 'sell',
  IMPORTS: 'upload',
  // Pairs with Imports: files going out, where Imports is files coming in.
  EXPORTS: 'download',
  LOCATIONS: 'location_on',
  BRANDS: 'bookmark',
  SUPPLIERS: 'local_shipping',
  BILLS: 'description',
  SUPPLIER_REFUNDS: 'inbox',
  TRANSACTIONS: 'receipt_long',
  VOUCHERS: 'confirmation_number',
  GIFT_RECEIPTS: 'card_giftcard',
  INVOICES: 'receipt',
  PAYMENT_METHODS: 'credit_card',
  // Stock that has fallen to its reorder point. `production_quantity_limits` is the
  // obvious Material choice and is NOT in this pack — an unlisted ligature renders
  // the `help` glyph, so it has to be one of these. `inventory` would near-duplicate
  // the Inventory section's own `inventory_2`, and nothing else in this submenu is a
  // chart, so the falling line reads unambiguously.
  REPLENISHMENT: 'trending_down',
  PURCHASE_ORDERS: 'add_shopping_cart',
  TRANSFER_ORDERS: 'compare_arrows',
  INVENTORY_RECEIVES: 'download',
  SHELF_LABELS: 'label',
  QUICK_UPDATES: 'bolt',
  INVENTORY_ADJUSTMENTS: 'tune',
  // A box, because the screen calls these packs throughout — a hamper and a pack of 25 are
  // the same thing here. 'account_tree' would say "made of parts", which is the part list
  // rather than the board. Nothing else in the nav uses 'package'.
  COMPOSITIONS: 'package',
  // A ticked sheet, because a stock take checks what is on the shelf against what the system expects.
  STOCK_TAKES: 'fact_check',
  INVENTORY_ITEM_EXPORT: 'output',
  SCHEDULED_EXPORTS: 'output',
  USERS: 'groups',
  COMPANIES: 'domain',
  CUSTOMER_SEGMENTS: 'hub',
  // Matches the dashboard insight, enrol slide-over, and enrollment feed
  MEMBERSHIPS: 'card_membership',
  // Distinct from Memberships' card_membership so the two sibling nav items don't share an icon
  MEMBERSHIP_CARDS: 'badge',
  MEMBERSHIP_PLANS: 'redeem',
  // Role administration under Contacts. 'shield' reads as "who is trusted with what".
  // Permissions is the capability catalogue behind it — 'policy' is the rulebook glyph,
  // distinct from the shield. Both are already in the icon subset.
  ROLES: 'shield',
  PERMISSIONS: 'policy',
  INTEGRATIONS: 'link',
  SETTINGS: 'settings',
  FEES: 'payments',
  ACCOUNTING_GROUPS: 'folder',
  // The rate itself, not the tax. 'percent' is the only glyph in the pack that says
  // "a rate" without borrowing a receipt or a document icon this submenu already uses.
  VAT_RATES: 'percent',
  PRINTER_REPORTS: 'monitoring',
  TRADING_WINDOW: 'event_busy',
  TILL_SESSIONS: 'point_of_sale',
  CASH_DRAWERS: 'local_atm',
  'Z-REPORTS': 'summarize',
  FISCAL_RECEIPTS: 'verified',
  // Finance > Balances: what each account owes, or is owed, ranked. A wallet holds a balance; 'account_balance'
  // is the bank glyph the statement's payment details already wear. Nothing else in the nav uses it.
  BALANCES: 'account_balance_wallet',
  SAGE_REPORTS: 'pie_chart',
  ITEMS: 'list',
  MODIFIERS: 'extension',
  CATEGORIES: 'category',
  MENUS: 'menu',
  TABLES: 'table_restaurant',
  // Distinct from Tables' table_restaurant — a booked seat, not the furniture.
  RESERVATIONS: 'event_seat',
  TIMETABLES: 'schedule',
  // The product is named after a town square, and the mark is one. A QR glyph
  // named one delivery mechanism out of the several this covers — takeaway and
  // the public directory arrive without a code being scanned — and it is the
  // brand, not the mechanism, that a venue owner is looking for in the nav.
  // ONLINE_ORDERING stays mapped alongside PJAZZA: the nav item was renamed, and
  // a stale key costs nothing next to an icon quietly vanishing.
  ONLINE_ORDERING: 'square',
  PJAZZA: 'square',
  DEVICES: 'tv',
  LICENSE_KEYS: 'key',
  CUSTOM_LAYOUTS: 'dashboard',
  DEFAULT_LAYOUT: 'vertical_align_center',
  POS_CAMPAIGNS: 'flag',
  POS_CONFIGURATION: 'settings',
  PRODUCTION_CENTERS: 'storage',
  PRODUCTION_MESSAGES: 'notes',
  PRINTERS: 'print',
  PRINT_ROUTES: 'alt_route',
  SIMULATOR: 'play_arrow',
  RECEIPT_TEMPLATES: 'receipt',
  DEVICE_TOPOLOGIES: 'schema',
  // One channel with tills radiating off it — the screen draws a hub, so it wears one.
  // Shares 'hub' with Customer Segments under Contacts; the two never appear together,
  // and 'schema' next door is already the topology-configuration glyph. 'lan' and
  // 'device_hub' would both read better and neither is in `IconPackConst`, which would
  // silently render the `help` glyph.
  SYNC_TOPOLOGY: 'hub',
  WORK_SESSIONS: 'history',
  // What an hour of staff time costs. Shares 'payments' with Fees, which is fine and
  // deliberate: the two never appear together, and this file already reuses a glyph across
  // submenus where the meaning holds ('flag' for both POS Campaigns and Sales Targets).
  // Matching the Pay Rates table and its slide-over matters more — one glyph for one concept,
  // wherever the concept appears. Currency glyphs like 'euro' were rejected for hard-coding a
  // currency the tenant may not use.
  PAY_RATES: 'payments',
  // Daily door footfall behind the conversion-rate metric. 'gate' reads as a physical
  // entry point; 'login' would be mistaken for staff clock-in next to Work Sessions.
  ENTRANCES: 'gate',
  // Daily per-location sales goal that syncs to the till — matches the 'flag' icon
  // used on the Targets page header and slide-over.
  SALES_TARGETS: 'flag',
  BARCODE_CONFIGURATIONS: 'qr_code',
  'BARCODES_&_LABELS': 'barcode_reader',
  TOOLBAR_CONFIGURATIONS: 'tune',
  // A strip of side-by-side panes, which is what a device's tab bar is. `tab`,
  // `tabs`, `web`, `apps` and `space_dashboard` are all absent from this pack.
  // Distinct from TOOLBAR_CONFIGURATIONS' 'tune' and CUSTOM_LAYOUTS' 'dashboard'.
  NAVIGATION_CONFIGURATIONS: 'view_column',
  CONFIGURATION: 'tune',
  // Settings > All Categories: every root category tree. Distinct from CATEGORIES' 'category'
  // (Products > Categories and the Category library) so the entries read differently side by side.
  ALL_CATEGORIES: 'category_search',
  // Settings > Branding: the tenant's logo and business details.
  BRANDING: 'palette',
  NOVA_SETTINGS: 'settings',
  // Landlord: every tenant. The same glyph the tenant table falls back to for a tenant with no logo.
  TENANTS: 'apartment',
  // Landlord: merchants waiting for approval. A person being added, distinct from Tenants' building.
  'SIGN-UPS': 'person_add'
}

const normalizeItemName = (name: string): string => {
  return name.toUpperCase().replace(/ /g, '_')
}

export { SINGLE_MENU_ITEM_ICON_MAPPER, normalizeItemName }
